import { Input } from 'govwell-ui'

import { TanstackField } from 'src/utils/forms'

type Props<TKey extends string> = {
  field: TanstackField<string, TKey>
  isRequired?: boolean
  label?: React.ReactNode
  width?: React.CSSProperties['width']
}

const ZipField = <TKey extends string>({ field, isRequired, label, width = 180 }: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  return (
    <Input
      label={label ?? 'Zip'}
      value={field.state.value}
      onValueChange={field.setValue}
      onBlur={field.handleBlur}
      placeholder="12345"
      errorMessage={errorMessage}
      isInvalid={!!errorMessage}
      isRequired={isRequired}
      width={width}
    />
  )
}

export default ZipField
